import { z } from "zod";
import { IntlShape } from "react-intl";
import { splitEmails } from "pages/admin-app/utils/splitEmails";
import { EMAIL_REGEX, MAX_EMAILS } from "pages/admin-app/adminapp.constants";

export const getIndustrySpecialistFormSchema = (intl: IntlShape) => {
  return z.object({
    name: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.nameRequired" }),
      })
      .trim()
      .min(1, intl.formatMessage({ id: "usAdmin.nameRequired" }))
      .refine((val) => !val.includes(","), {
        message: intl.formatMessage({ id: "usAdmin.noCommasAllowed" }),
      }),
    email: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.emailRequired" }),
      })
      .trim()
      .nonempty(intl.formatMessage({ id: "usAdmin.emailRequired" }))
      .refine(
        (val) => {
          const emails = splitEmails(val);
          return emails.length <= MAX_EMAILS;
        },
        {
          message: intl.formatMessage({ id: "usAdmin.tooManyEmails" }),
        }
      )
      .refine(
        (val) => {
          const emails = splitEmails(val);
          return emails.every((e) => EMAIL_REGEX.test(e));
        },
        {
          message: intl.formatMessage({ id: "usAdmin.invalidEmail" }),
        }
      ),
  });
};

export type IndustrySpecialistFormData = z.infer<
  ReturnType<typeof getIndustrySpecialistFormSchema>
>;
